/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 連絡先情報
 */
export interface Sgkb575aResCncttoInfo {
    /** 
     * 事前連絡コード：半角英数混在
     */
    advtelCode?: string;
    /** 
     * 事前連絡コード名称：全角半角混在
     */
    advtelCodeAname?: string;
}
